import { render, staticRenderFns } from "./GameFooterBar.vue?vue&type=template&id=6a649b02&scoped=true&"
import script from "./GameFooterBar.vue?vue&type=script&lang=js&"
export * from "./GameFooterBar.vue?vue&type=script&lang=js&"
import style0 from "./GameFooterBar.vue?vue&type=style&index=0&id=6a649b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a649b02",
  null
  
)

export default component.exports